import { useMemo } from "react";
import VideoCard from "@/components/feature/VideoCard";
import type { Video } from "@/types/video";
import { videos } from "@/mocks/videos";

export default function RelatedVideos({ video }: { video: Video }) {
  const related = useMemo(() => {
    const sameCategory = videos.filter(
      (item) => item.categorySlug === video.categorySlug && item.id !== video.id
    );
    return [...sameCategory]
      .sort((a, b) => new Date(b.uploadDate).getTime() - new Date(a.uploadDate).getTime())
      .slice(0, 5);
  }, [video]);

  if (related.length === 0) return null;

  return (
    <section>
      <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950">相关推荐</h2>
      <p className="mt-1 text-sm text-foreground-500">同类别的热门内容，继续发现更多精彩</p>
      <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-x-5 gap-y-7">
        {related.map((item) => (
          <VideoCard key={item.id} video={item} />
        ))}
      </div>
    </section>
  );
}